<template>
	<div>
		<div class="dashboard-text">
			<img src="../../../assets/oa/approve-back.png" alt="" style="margin-right: 5px;" @click="closeBackTwo()">
			<span>发起审批</span>
		</div>
		<div>
			<div class="dashboard-contentTwo" style="padding: 30px;">
				<VFormReader class="form" :form-json="formJson" :form-data="formData" :option-data="optionData"
					ref="vFormRef">
				</VFormReader>
				<div style="height: 100px;"></div>
			</div>
			<!-- <div class="dashboard-contentTwo" style="margin-top:20px;padding-bottom: 50px;">
				<div style="line-height: 50px;margin-left: 20px;font-size: 16px;font-weight:600">流程</div>
				<div style="line-height: 50px;margin-left: 20px;font-size: 16px;">审批人</div>
				<div v-for="(item,index) in peopleList">
					<div style="margin: 10px 0 20px 20px;display: flex;float: left;">
						<div>
							<el-avatar :size="50" icon="el-icon-user-solid" style="width: 50px;height:50px"></el-avatar>
							<div style="text-align: center;">{{item.staff_name}}</div>
						</div>
						<div><i v-if="index != peopleList.length - 1" class="el-icon-arrow-right"
								style="font-size: 30px;margin: 15px 10px;color: #92959c;"></i>
						</div>
					</div>
				</div>
				<div>
					<el-upload class="avatar-uploader" action="https://jsonplaceholder.typicode.com/posts/"
						:show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
						<img v-if="imageUrl" :src="imageUrl" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</div>
			</div> -->
			<div class="dashboard-contentTwo" style="margin-bottom: 30px;">
				<div style="margin-top: 60px;margin-left: 20px;padding-bottom:30px">
					<el-button type="goon" @click="submitForm">提交</el-button>
				</div>
			</div>
		</div>
		<el-dialog title="审核" :visible.sync="spShow" width="35%" center="true" :close-on-click-modal="false">
			<div style="width: 100%;">
				<div v-if="dataObject.ejectType == 23"
					style="display: flex;justify-content: space-around;line-height: 50px;">
					<div>预算总金额:{{ dataObject.annual }}</div>
					<div>已执行金额:{{ dataObject.budget }}</div>
					<div>本次执行金额:{{ dataObject.amount_money }}</div>
				</div>
				<el-table ref="multipleTable" :header-cell-style="{ background: '#F0F0F0', color: '#000000' }"
					:data="examineDetailsList" tooltip-effect="dark" style="width: 100%" height="300">
					<el-table-column label="序号" width="50">
						<template slot-scope="scope_1">{{ scope_1.$index + 1 }}</template>
					</el-table-column>
					<el-table-column prop="node" label="节点" align="center">
					</el-table-column>
					<el-table-column prop="role_name" label="岗位" align="center">
					</el-table-column>
					<el-table-column prop="staff_name" label="审核人" align="center">
					</el-table-column>
				</el-table>
				<div style="text-align: center;margin-top: 10px;" v-if="dataObject.isSubmit">
					<el-button type="goon" @click="findTwo()">确定</el-button>
				</div>
			</div>
			<div style="height: 30px;"></div>
		</el-dialog>
	</div>
</template>

<script>
import VFormReader from './../../form-render/index.vue'
import axios from "axios";
// import { baseRequest } from '@/api/system'
export default {
	props: ["collapseId"],
	components: { VFormReader },
	data() {
		return {
			spShow: false,
			tableList: [],
			examineDetailsList: [],
			rowId: '',

			formJson: {},
			formData: {},
			optionData: {},
			peopleList: [],
			imageUrl: '',
			ruleForm: {
				name: ''
			},
			ruleRules: {
				name: [{
					required: true,
					trigger: "blur",
					message: "必填项不能为空"
				}],
			},
			headers: {},
			set_id: '',
			proposed_id: '',
			apiURL: '',
			fileListOne: [],

			dataObject: {}
		}
	},
	mounted() {
		//////////////////获取保存的表单数据//////////////////////
		// const url2 = this.$globals.http + "OaManageSet/findFormById";
		// axios.post(url2, {
		// 	id: this.collapseId
		// }).then((response) => {
		// 	var code = response.data.code;
		// 	var data = response.data.data;
		// 	let newFormData = null
		// 	if (code == 200) {
		// 		this.peopleList = data.examineDetailsList;
		// 		newFormData = data
		// 	}

		//////////////////获取保存的表单//////////////////////
		const url = this.$globals.http + "OaManageSet/findFormById";
		axios.post(url, {
			id: this.collapseId
		}).then((response) => {
			var code = response.data.code;
			var data = response.data.data;
			if (code === '200') {
				this.peopleList = data.examineDetailsList;
				this.set_id = data.set_id;
				this.proposed_id = this.$globals.user.staff_id;
				this.$refs.vFormRef.setFormJson(data.form)
				// this.$nextTick(() => {
				//     this.$refs.vFormRef.setFormData(newFormData)
				// })
			}
		})
		// })




	},
	methods: {
		async findTwo() {
			var data = await this.$globals.AxiosPost('OaManageApproval/add', {
				set_id: this.set_id,
				proposed_id: this.proposed_id,
				data: this.formData,
				approval: this.dataObject.approval
			});
			if (data === '-2000') {
				this.$message.error('服务器未响应！请稍后重试');
			} else {
				var code = data.code;
				var data = data.message;
				console.log(data);
				if (code === '200') {
					this.$message.success(data);
					this.closeBackTwo()
				} else {
					this.$message.warning('请求失败！请稍后重试');
				}
			}
		},
		async submitForm() {
			this.$refs.vFormRef.getFormData().then(formData => {
				this.formData = formData
				var record = {
					set_id: this.set_id,
					proposed_id: this.proposed_id,
					data: formData,
				};
				const url = this.$globals.http + "OaManageApproval/getAnnualOaManageApproval";
				axios.post(url, record).then((response) => {
					var code = response.data.code;
					this.dataObject = response.data.data;
					this.examineDetailsList = this.dataObject.approval.examineDetailsList

					if (code === '200') {
						if (this.dataObject.isEject) this.spShow = true
					}
				})
			}).catch(error => {
				// Form Validation failed
				this.$message.error(error)
			})
		},
		handleAvatarSuccessBasic(res, file, row) { //成功 
			console.log(res.data);
			this.form.fileUrl = res.data.fileUrl
			this.$message.success({
				message: '操作成功'
			})
		},
		handleRemoveBasic(res, file, row) { //移除
			console.log(res.data);
			this.form.fileUrl = ''
		},
		handleExceed(files, fileList) { //上传限制
			this.$message.warning(`当前限制选择1个文件，上传文件大小不能超过100M`);
		},
		closeBackTwo() {
			this.$emit('closeBackTwo')
		},
		clickBtn(type, item) {
			let that = this;
			const TYPE_METHODS = {
				[""]() { },
			};
			TYPE_METHODS[type]();
		},
	}
}
</script>

<style>
.el-form-item__label {
	font-size: 14px;
}

.el-form--inline .el-form-item__label {
	text-align: left;
}

.form .field-wrapper {
	margin-left: 10px;
}

.form .el-input__inner {
	width: 95%;
	margin-top: 2px;
}
</style>
<style scoped>
.avatar-uploader {
	margin-top: 10px;
	width: 50px;
	height: 50px;
	border: 1px dashed #8c939d;
	border-radius: 6px;
	position: relative;
	overflow: hidden;
}

.avatar-uploader-icon {
	font-size: 12px;
	color: #8c939d;
	width: 50px;
	height: 50px;
	line-height: 50px;
	text-align: center;
}

.avatar {
	width: 178px;
	height: 178px;
	display: block;
}

.upload-titleTwo {
	font-size: 14px;
	line-height: 30px;
	margin-top: 10px;
}

.upload-title {
	font-size: 14px;
	line-height: 30px;
}

.expense-label-title {
	display: flex;
	justify-content: space-between;
	font-size: 14px;
	border-bottom: 1px solid #c1c1c1;
	line-height: 30px;
	margin-bottom: 10px;
}

.expense-label {
	font-size: 14px;
	line-height: 30px;
	position: relative;
}

.expense-label::before {
	width: 10px;
	height: 10px;
	content: '*';
	color: red;
	font-size: 20px;
	position: absolute;
	left: -10px;
	top: 3px;
}

.expense-title {
	font-size: 19px;
	font-weight: 600;
	margin-bottom: 30px;
}

.dashboard-text {
	font-size: 20px;
	margin: 36px 0 10px 40px;
	font-weight: 600;
	display: flex;
	align-items: center;
}

.dashboard-contentTwo {
	background: #fff;
	font-size: 16px;
	border: 1px solid transparent;
	margin: 0 40px;
}

.dashboard-button {
	width: 85px;
	background: #006E4B;
	color: #FFFFFF;
	border: 1px solid #006E4B;
}

.dashboard-buttonWhite {
	width: 85px;
	color: #006E4B;
	border: 1px solid #006E4B;
}
</style>



// WEBPACK FOOTER //
// expenseReimburse.vue?cc5c2534